<template>
    <div class="CreateActive">

        <el-form ref="form" :model="form" label-width="135px" :rules="rules" label-position="left">

            <section class="spackage padding-20 bgc box-shadow">
                <header>
                    <h1>基本信息</h1>
                </header>
                <div class="content">

                    <el-form-item label="活动标题" prop="title">
                        <el-input v-model="form.title" placeholder="输入活动标题，不超过40字" maxlength="40" show-word-limit></el-input>
                    </el-form-item>

                    <el-form-item label="活动简介" prop="subtitle">
                        <el-input type="textarea" v-model="form.subtitle" placeholder="输入副活动标题，不超过50个字" maxlength="50" show-word-limit style="width: 400px"></el-input>
                    </el-form-item>

                    <el-form-item label="活动封面" class="cover" prop="coveratturlid">
                           <div class="upload">
                                <div class="avatar-uploader imgBox">
                                    <i class="el-icon-picture" v-if="!form.coveratturlid.furl"></i>
                                    <img class="activityCoverImage" :src="form.coveratturlid.furl + '?' + time" v-else-if="form.coveratturlid.furl + '?' + time" alt="">
                                </div>
                                <div class="position uploadFileBox">
                                    <!-- <UploadFile :uploadType="uploadVideoType" @setFile="setFile" :fileRule="fileRule"></UploadFile> -->
                                    <el-button @click.native="openDialog">选择文件</el-button>
                                    <p>建议尺寸750*420px的JPG、PNG格式， 图片小于2M。</p>
                                </div>
                           </div>
                    </el-form-item>

                    <!-- <el-form-item label="活动封面" prop="coveratturlid">
                        <div class="upload">
                            <upload class="avatar-uploader" :imgRule="imgRule"  @setImage="setCoverfile" :uploadType="uploadType" ref="coverfile"></upload>
                            <div class="position">
                                <el-button @setImage="setCoverfile">选择文件</el-button>
                                <p>建议上传尺寸750*420，jpg或png格式，不超过2M</p>
                            </div>
                        </div>
                    </el-form-item> -->
                    <el-form-item label="活动城市" class="isRequire enrollcityname" prop="enrollcityname">
                        <el-select v-model="form.enrollcityname" placeholder="请选择">
                            <el-option v-for="item in cityOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                        <!-- <el-cascader placeholder="请选择活动城市" :options="citysList" @change="selectedCity" ref="myCascader"  v-model="currentCity"></el-cascader> -->
                    </el-form-item>
                    <el-form-item label="活动地点" prop="address">
                        <!-- <div @click="showLocationDialog" class="address">
                            <el-input v-model="form.address" placeholder="选择活动地点" :disabled="true"></el-input>
                        </div> -->
                        <!-- <div @click="showLocationDialog" class="address"> -->
                            <el-input v-model="form.address" placeholder="输入活动地点"></el-input>
                        <!-- </div> -->
                    </el-form-item>

                    <el-form-item label="活动人数">
                        <el-input v-model="form.peoplecount" placeholder="0为不限制"></el-input>
                    </el-form-item>


                     <el-form-item label="活动时间段" prop="date" class="date">
                        <!-- <el-date-picker id="datePicker" v-model="ruleForm.date" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker> -->
                        <el-date-picker v-model="form.begintime" value-format="yyyy-MM-dd HH:mm:ss" :disabled="activeStatus" type="datetime" placeholder="选择活动开始时间"></el-date-picker>
                        <span class="to">至</span>
                        <el-date-picker v-model="form.endtime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择活动结束时间"></el-date-picker>
                    </el-form-item>

                    <!-- <el-form-item label="活动时间段" prop="activeTime">
                        
                        <el-date-picker
                            v-model="activeTime"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd HH:mm:ss" 
                            value-format="yyyy-MM-dd HH:mm:ss"
                            style="width: 400px">
                            </el-date-picker>
                    </el-form-item> -->

                    <el-form-item label="报名时间段" required>
                        <el-radio-group v-model="form.enrolltimetype">
                            <el-radio v-for="item in enrolltimetype" :label="item.value">{{item.label}}</el-radio>
                        </el-radio-group>

                        <el-date-picker v-show="form.enrolltimetype == 2"
                            v-model="submitTime"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            style="width: 400px; display: flex">
                        </el-date-picker>

                    </el-form-item>

                    <el-form-item label="活动详情" prop="eventdesp">
                        <div class="ueditorBox">
                            <uEditor :content="form.eventdesp" ref="uEditor" @getUEditorContent="getUEditorContent"></uEditor>
                        </div>
                    </el-form-item>

                </div>

            </section>
            <!-- end 基本信息 -->

            <section class="spackage padding-20 bgc box-shadow ticket-info">
                <header>
                    <h1>票务信息</h1>
                </header>
                <div class="content">

                    <el-table :data="form.ticketinfolist" :class="{'none': form.ticketinfolist.length == 0}" style="width: 879px">
                        <el-table-column
                            label="票种名称"
                            prop="name"
                            align="center">
                        </el-table-column>
                        <el-table-column
                            label="价格（元）"
                            align="center">
                            <template slot-scope="scope">
                                <p v-if="scope.row.tickettype == 1">免费</p>
                                <p v-if="scope.row.tickettype == 2">¥ {{scope.row.uprice}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="validcount"
                            align="center">
                            <template slot="header" slot-scope="scope">

                                <span class="txt" v-if="form.eventinnerid && ! copy">余票</span>
                                <span class="txt" v-else>票数</span>

                                <el-tooltip class="item" effect="dark" placement="top">
                                    <div slot="content">
                                    总票种张数不可大于活动总人数 
                                    </div>
                                    <i class="el-icon-warning-outline"></i>
                                </el-tooltip>
                            </template>
                        </el-table-column>

                        <el-table-column prop="isaudit" align="center">
                            <template slot="header" slot-scope="scope">
                                <span class="txt">审核设置</span>
                                <el-tooltip class="item" effect="dark" placement="top">
                                    <div slot="content">
                                        开启后，用户先提交报名表等待审核，<br/>审核通过后如果要付费才去支付，过<br/>期不支付则自动作废，不需支付则报<br/>名成功。
                                    </div>
                                    <i class="el-icon-warning-outline"></i>
                                </el-tooltip>
                            </template>
                            <template slot-scope="scope">
                                <p v-show="scope.row.isaudit === 0">不需要审核</p>
                                <p v-show="scope.row.isaudit === 1">需要审核</p>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="操作">
                            <template slot-scope="scope">
                                <span>
                                    <i style="cursor: pointer" class="el-icon-edit-outline" @click="updatePw(scope.$index)"></i>
                                    <i style="margin-left: 10px; cursor: pointer" class="el-icon-delete" @click="delPw(scope.$index)"></i>  
                                </span>    
                            </template>                        
                        </el-table-column>
                    </el-table>

                    <div class="ticket-info-table" v-show="tableStatus">
                        <div class="head flexd" >
                            <el-input placeholder="票种名称" v-model="ticketinfolist.name" maxlength="6"></el-input>

                            <el-input placeholder="免费" :disabled="true" v-if="ticketinfolist.tickettype == 1"></el-input>
                            <el-input placeholder="票种价格" v-model="ticketinfolist.uprice" v-if="ticketinfolist.tickettype == 2"></el-input>
                            <el-input placeholder="票种张数" v-model="ticketinfolist.validcount" min="1"></el-input>

                            <el-select v-model="ticketinfolist.isaudit" placeholder="选择审核方式">
                                <el-option
                                v-for="item in isauditState"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                            <span>
                                <el-button @click="calcelTable()">取消</el-button>
                                <el-button type="primary" @click="submitTable()">确定</el-button>
                            </span>
                        </div>

                        <div class="flexd">
                            <p>票种说明（选填）</p>
                            <el-input v-model="ticketinfolist.memo" type="textarea" class="bmtable-content" maxlength="40" show-word-limit></el-input>
                        </div>
                        <div class="flexd">
                            <p>限购设置</p>
                            <div class="bmtable-content">
                                <p>单次下单最多可购买 <span class="txt"><el-input v-model="ticketinfolist.maxbuycountbysingle" style="width: 72px"></el-input></span> 张 <span class="txt">默认为 1，0 表示不限制购买张数</span></p>
                            </div>
                        </div>

                        <div class="flexd" v-show="ticketinfolist.tickettype == 2">
                            <p>套票设置</p>
                            <div class="bmtable-content">
                                <p><span class="txt"><el-input v-model="ticketinfolist.seasonticketcount"  min="1" max="100" style="width: 72px"></el-input></span>人票 <span class="txt">设置单次购买票数，可输入 1-100</span></p>
                            </div>
                        </div>
                        <!-- 收费票时进行展示 -->

                    </div>

                    <div class="table-btn">
                        <el-button type="primary" plain @click="addTable(1)">添加免费票</el-button>
                        <el-button type="primary" plain @click="addTable(2)">添加收费票</el-button>
                    </div>
                </div>

                <el-form-item label="是否支持退款" prop="isrefund" :disabled="afterTheStartDisabled">
                        <el-radio-group v-model="form.isrefund" :disabled="startStatus">
                            <el-radio v-for="item in isrefundState" :label="item.value">{{item.label}}</el-radio>
                        </el-radio-group>
                        <p class="txt">在活动开始前是否支持退款</p>
                </el-form-item>

                <el-form-item label="报名人数显示" prop="isdisplayenrollcount" required :disabled="noCutoffDisabled">
                        <el-radio-group v-model="form.isdisplayenrollcount" :disabled="endStatus">
                            <el-radio v-for="item in buttonState" :label="item.value">{{item.label}}</el-radio>
                        </el-radio-group>
                        <p class="txt">开启后会显示已购票成功的人数（作废的票不算）</p>
                </el-form-item>

                <el-form-item label="公开报名数据" prop="isdisplayenrollinfo" required :disabled="noCutoffDisabled">
                        <el-radio-group v-model="form.isdisplayenrollinfo" :disabled="endStatus">
                           <el-radio v-for="item in buttonState" :label="item.value">{{item.label}}</el-radio>
                        </el-radio-group>
                        <p class="txt">选择公开，在前端可展示报名人员的信息</p>
                </el-form-item>

                <el-form-item label="线下签到设置" prop="isopensignin" required :disabled="noCutoffDisabled">
                        <el-radio-group v-model="form.isopensignin" :disabled="endStatus">
                          <el-radio v-for="item in buttonState" :label="item.value">{{item.label}}</el-radio>
                        </el-radio-group>
                        <p class="txt">活动开始前参与人可以用手机扫描二维码进行签到</p>
                </el-form-item>
                
                <el-form-item label="提醒通知设置" prop="isopennotify" required :disabled="noCutoffDisabled">
                        <el-radio-group v-model="form.isopennotify">
                           <el-radio v-for="item in buttonState" :label="item.value">{{item.label}}</el-radio>
                        </el-radio-group>
                        <p class="txt">目前通知范围包含：报名成功提醒、审核成功提醒、签到通知</p>
                </el-form-item>

                <el-form-item label="短信通知" prop="isopensmsnotify" required :disabled="noCutoffDisabled">
                        <el-radio-group v-model="form.isopensmsnotify" :disabled="endStatus">
                            <el-radio v-for="item in buttonState" :label="item.value">{{item.label}}</el-radio>
                        </el-radio-group>
                        <p class="txt">开启后，将通过短信发送以上通知类型。短信数量为0时用户将无法收到短信。</p>
                </el-form-item>
            </section>
            <!-- end 票务信息 -->

            <section class="spackage padding-20 bgc box-shadow  bmtable">
                <header>
                    <h1>报名表单</h1>
                </header>
                <div class="content flexd">
                    <div class="left">
                        <el-form-item label="是否报名信息收集" prop="iscollectenrollinfo" required>
                            <el-radio-group v-model="form.iscollectenrollinfo">
                                <el-radio v-for="item in buttonState" :label="item.value">{{item.label}}</el-radio>
                            </el-radio-group>
                            <p class="txt">开启后，对于购买多张票的用户，需要填写每张票对应的参与人信息</p>
                        </el-form-item>

                        <div class="flexd">
                            <!-- <el-checkbox-group v-model="checked"> -->
                                <el-checkbox label="必填"  v-model="checked" :disabled="true"></el-checkbox>
                            <!-- </el-checkbox-group> -->
                            <div class="name">
                                <p>姓名</p>
                            </div>
                            <div class="input">
                                <el-input class="maxinput" placeholder="报名用户的姓名或者昵称" :disabled="true"></el-input>
                            </div>
                        </div>

                         <div class="flexd">
                            <!-- <el-checkbox-group v-model="checked"> -->
                                <el-checkbox label="必填"  v-model="checked" :disabled="true"></el-checkbox>
                            <!-- </el-checkbox-group> -->
                            <div class="name">
                                <p>手机</p>
                            </div>
                            <div class="input">
                                <el-input class="maxinput"  placeholder="报名用户的手机" :disabled="true"></el-input>
                            </div>
                        </div>

                        <p class="title">更多信息</p>

                        <div>
                            <section v-for="(item, index) in form.enrollformlist">
                                <!-- v-if="item.colname == '姓名' && item.colindex == 1 ||  item.colname == '手机' && item.colindex == 2" -->
                                <!--  coltype 字段类型： 1 单行文本框 2 数字文本框  3 日期选择框  4 邮箱输入框 5 多行文本框6 单选按钮框 7 多选按钮框 8 下拉选择框  -->
                                <div class="flexd" v-if="item.coltype == 1 || item.coltype == 2 || item.coltype == 3 || item.coltype == 4">
                                    <el-checkbox-group v-model="item.isnotnull">
                                        <el-checkbox label="必填"></el-checkbox>
                                    </el-checkbox-group>
                                    <div class="name">
                                        <el-input placeholder="日期文本框" v-if="item.coltype == 3" v-model="item.colname" maxlength="8"></el-input>
                                        <el-input placeholder="单行文本框" v-else v-model="item.colname" maxlength="8"></el-input>
                                    </div>
                                    <div class="input">
                                        <el-input class="maxinput" v-model="item.placeholder"  placeholder="可输入提示信息"></el-input>
                                    </div>
                                    <i class="el-icon-delete" @click="delTableItem(index)"></i>
                                </div>

                                <div class="flexd" v-if="item.coltype == 5">
                                    <el-checkbox-group v-model="item.isnotnull">
                                        <el-checkbox label="必填"></el-checkbox>
                                    </el-checkbox-group>
                                    <div class="name">
                                        <el-input placeholder="多行文本框" v-model="item.colname" maxlength="8"></el-input>
                                    </div>
                                    <div class="input">
                                        <el-input class="maxinput" v-model="item.placeholder"   placeholder="可输入提示信息"></el-input>
                                    </div>
                                    <i class="el-icon-delete" @click="delTableItem(index)"></i>
                                </div>

                                <div class="flexd item-list" v-if="item.coltype == 6 || item.coltype == 7 || item.coltype == 8">
                                    <el-checkbox-group v-model="item.isnotnull">
                                        <el-checkbox label="必填"></el-checkbox>
                                    </el-checkbox-group>
                                    <div class="name">
                                        <el-input placeholder="选择项" v-model="item.colname" maxlength="8"></el-input>
                                    </div>
                                    <div class="input list">
                                        <p class="list-title">选项列表</p>

                                        <template v-for="(selectitem,seindex) in item.optionsinfo">
                                            <el-input class="maxinput" v-model="selectitem.value" v-if="seindex < 2" :placeholder="'选项'+(seindex + 1)" ></el-input>
                                            <!--  v-model="selectitem" <el-input class="maxinput" placeholder="选项二"></el-input> -->

                                            <div class="flexd" v-else>
                                                <el-input class="maxinput" v-model="selectitem.value" :placeholder="'选项'+(seindex+1)"></el-input>
                                                <i class="el-icon-delete" @click="delSelectitem(index, seindex)"></i>
                                            </div>
                                        </template>
                                    
                                        <el-button type="primary" plain @click="addSelectItem(index)">添加选项</el-button>
                                    </div>
                                    <i class="el-icon-delete" @click="delTableItem(index)"></i>
                                </div>
                            </section>
                        </div>
                    </div>
                    <div class="right">
                            <!---自定义项--->
                            <div class="usedItems customItems">
                                <p>自定义栏位</p>
                                <ul>
                                    <li class="flexd" @click="setZidingyiForms('1')"><img src="./../../../common/images/activeOperate/icon-danhangwenben.png">单行文本框</li>
                                    <li class="flexd" @click="setZidingyiForms('5')"><img src="./../../../common/images/activeOperate/icon-duohangwenben.png">多行文本框</li>
                                    <li class="flexd" @click="setZidingyiForms('7')"><img src="./../../../common/images/activeOperate/icon-duoxuan.png">多选按钮框</li>
                                    <li class="flexd" @click="setZidingyiForms('6')"><img src="./../../../common/images/activeOperate/icon-danxuan.png">单选按钮框</li>
                                    <li class="flexd" @click="setZidingyiForms('8')"><img src="./../../../common/images/activeOperate/icon-xiala.png">下拉选择框</li>
                                    <li class="flexd" @click="setZidingyiForms('3')"><img src="./../../../common/images/activeOperate/icon-riqi.png">日期选择框</li>
                                </ul>
                            </div>
                    </div>
                </div>
            </section>
            <!-- end 报名表单 -->

            <section class="spackage padding-20 bgc box-shadow positionbtn">
                <span>
                    <el-button @click="back()">取消</el-button>
                    <el-button type="primary" @click="saveEnrolleventinfo()" v-if="endActive == false && form.createsourcetype !== 2">提交</el-button>
                </span>
            </section>
            <!-- end 提交按钮 -->
        </el-form>

        <!-- 裁图 -->
        <ShopLocalCropper :cropperOption="cropperOption" ref="localCropper" @setImage="_setImage" :uploadType="uploadType"></ShopLocalCropper>
        <!-- 活动地点 -->
        <ChooseLocation v-if="($route.query.eventinnerid && form.title) || !$route.query.eventinnerid" :lat="form.latitude_baidu" :lng="form.longitude_baidu" :provincename="form.mapprovince" :cityname="form.mapcity" :currentArea="form.address" :locationDialog="locationDialogStatus" @close="locationDialogStatus=false" @thePosition="getThePosition" />
    </div>
</template>

<script>
import Upload from 'base/upload/upload'
import UEditor from 'base/uEditor/uEditor'
import ShopLocalCropper from 'base/cropper/shopLocalCropper'
import fecha from 'element-ui/src/utils/date'
import { urlToQRCode} from 'common/js/tools'
import { mapActions} from 'vuex' // 引入 vuex 组件
import $ from 'jquery'
import ChooseLocation from 'views/activeOperate/components/chooseLocation'
import {saveEnrolleventinfo, getEnrolleventinfoDetail} from 'api/activeApi'

export default {
        name: "CreateActive",
        data() {
            let checkdate = (rule, value, callback) => {
                let now = new Date().getTime()
                if (!this.form.begintime || !this.form.endtime) {
                    if (!this.form.begintime) {
                        callback('请选择活动开始时间')
                    } else if (!this.form.endtime) {
                        callback('请选择活动结束时间')
                    }
                } else if (new Date(this.form.endtime).getTime() === new Date(this.form.begintime).getTime() || new Date(this.form.endtime).getTime() < new Date(this.form.begintime).getTime()) {
                    callback('活动开始时间不能小于等于结束时间')
                } else {
                    callback()
                }
            }
            return {
                cityOptions: [
                    {value: '北京', label: '北京'},
                    {value: '上海', label: '上海'},
                    {value: '广州', label: '广州'},
                    {value: '深圳', label: '深圳'},
                    {value: '杭州', label: '杭州'},
                    {value: '武汉', label: '武汉'},
                    {value: '成都', label: '成都'},
                    {value: '长沙', label: '长沙'},
                    {value: '南京', label: '南京'},
                    {value: '重庆', label: '重庆'},
                    {value: '苏州', label: '苏州'},
                    {value: '其他', label: '其他'},
                ],
                CheckIndex: null, // 选中的下标
                noCutoffDisabled: false,// 报名开始未截止都可编辑
                endActive: false, // 活动结束
                activeStatus: false,
                startStatus: false, // 开始报名状态
                endStatus: false,  // 结束报名状态
                copy: this.$route.query.title,   // 是否为复制活动
                afterTheStartDisabled: false, // 报名开始后不可编辑
                locationDialogStatus: false, // 活动地址选择弹窗
                time: new Date().getTime(),
                updayeTable: false, // 是否为票种编辑情况
                tableStatus: false, // 票种表单
                activeTime: "", // 活动时间段
                checked: true, // 默认状态
                submitTime: "", // 报名时间段
                isauditState: [{value: 1, label: '需要审核'}, {value: 0, label: '不需要审核'}], // 审核方式状态
                buttonState: [{value: 1, label: '开启'}, {value: 0, label: '关闭'}], // 按钮状态
                isrefundState: [{value: 1, label: '支持退款'}, {value: 0, label: '不支持退款'}],   // 退款状态
                imgRule: {  // 图片
                    cls: 'icon_upload',
                    accept: 'image/png,image/jpeg',
                    size: 2,
                    width: '',
                    height: ''
                },
                uploadType: {
                    catecode: '95',
                    datatype: 'IMAGE'
                },
                //当前选择票种信息
                ticketinfolist: { //票种信息list 
                            // ticketindex: '', // 票种序号
                            tickettype: 1, // 票种费用类型:1免费 2收费
                            name: '', // 票种名称
                            ticketcount: '', // 总票数
                            validcount: '', // 剩余票数
                            uprice: '', // 票价格
                            isaudit: 0, // 是否审核：0不审核 1审核
                            memo: '', // 票种说明
                            seasonticketcount: 1, // 套票设置：默认为1
                            maxbuycountbysingle: 1, // 单次购买最多数
                            innerid: '',    // 票种innerid
                }, 
                enrolltimetype: [{ label:"活动发布后至活动结束前", value: 1},{label:"自定义报名时间", value: 2}],   // 报名时间类型
                form: {
                    eventinnerid: this.$route.query.eventinnerid, // 活动ID
                    title: '', // 活动标题
                    subtitle: '', // 活动简介
                    coveratturlid: '', // 活动Logo图对象
                    begintime: '', // 活动开始时间
                    endtime: '', // 活动结束时间
                    typecode: '', // 活动类型Code
                    typename: '', // 活动类型名称
                    address: '', // 活动地点
                    // provinceid: '', // 活动省份ID
                    // cityid: '', // 活动城市ID
                    // province: '', // 活动省份名称
                    // city: '', // 活动城市名称
                    // longitude_baidu: '', // 活动地点经度
                    // latitude_baidu: '', // 活动地点维度
                    enrolltimetype: 1, // 报名时间类型： 1 活动发布后至活动结束前  2 自定义报名时间
                    enrollbegintime: '', // 报名开始时间
                    enrollendtime: '', // 报名结束时间
                    eventdesp: '', // 活动详情
                    isrefund: 1, // 是否支持退款
                    peoplecount: '', // 活动人数
                    createsourcetype: 1, // 创建来源类型   1 PC  2小程序 
                    isopensmsnotify: 1, // 是否开启短信通知   0否   1是
                    iscopy: 0,  // 是否为复制活动   0否   1是
                    //票种信息
                    ticketinfolist: [ //票种信息list 
                        // {
                        //     ticketindex: '', // 票种序号
                        //     tickettype: '', // 票种费用类型:1免费 2收费
                        //     name: '', // 票种名称
                        //     ticketcount: '', // 票数
                        //     uprice: '', // 票价格
                        //     isaudit: '1', // 是否审核：0不审核 1审核
                        //     memo: '', // 票种说明
                        //     seasonticketcount: 1, // 套票设置：默认为1
                        //     maxbuycountbysingle: '', // 单次购买最多数
                        // }
                    ], 
                    //活动信息设置表
                    isdisplayenrollcount: 1, // 是否显示报名人数  0关闭 1开启
                    isdisplayenrollinfo: 1, // 是否公开报名数据  0关闭 1开启 
                    isopensignin: 1, // 线下签到设置  0关闭 1开启
                    isopennotify: 1, // 提醒通知设置  0关闭 1开启
                    iscollectenrollinfo: 1, // 是否手机报名信息： 0关闭 1开启
                    //活动报名表单表
                    enrollformlist: [
                        // { //  表单list
                        //     colinnerid: '', // 表单InnerID
                        //     colname: '', // 字段名称 
                        //     colindex: '', // 序号 
                        //     coltype: '', // 字段类型： 1 单行文本框 2 数字文本框  3 日期选择框  4 邮箱输入框 5 多行文本框6 单选按钮框 7 多选按钮框 8 下拉选择框  \n
                        //     placeholder: '', // 字段提示语
                        //     optionsinfo: [], // 下拉选项表：表单提交时 多个以逗号隔开
                        //     isnotnull: '', // 是否必填" 
                        //     ispublic: 0,   // 是否公开
                        // }
                    ], 
                    enrollcityname: '', // 活动城市
                    latitude_baidu: '0', // 
                    longitude_baidu: '0', // 
                    mapprovince: '0',
                    mapcity: '0'
                },
                cropperOption: {
                    fixedNumber: [750, 420], // 截图框的宽高比例
                    enlarge: 4.4, // 图片根据截图框输出比例倍数
                    autoCropWidth: 170, // 默认生成截图框宽度
                    autoCropHeight: 100 // 默认生成截图框高度
                },
              rules: {
                title: [
                    { required: true, message: '请输入活动标题', trigger: 'blur' }
                ],
                coveratturlid: [
                    { required: true, message: '请选择活动封面', trigger: 'blur' }
                ],
                address: [
                    { required: true, message: '请输入活动地点', trigger: 'blur' }
                ],
                peoplecount: [
                    { required: true, message: '请输入活动人数', trigger: 'blur' }
                ],
                date: [
                    {validator: checkdate, trigger: 'blur'}
                ],
                eventdesp: [
                    { required: true, message: '请输入活动详情', trigger: 'blur' }
                ],
                enrollcityname: [
                    { required: true, message: '请选择活动城市', trigger: 'blur' }
                ]
              },
          }
        },
        mounted() {
            if (this.form.eventinnerid) {
                this.setLoading(true)
                getEnrolleventinfoDetail({
                    data: {eventinnerid: this.form.eventinnerid},
                    success: data => {
                        this.setLoading(false)
                        let form = data.data
                        // 活动详情
                        this.$refs.uEditor.init(form.eventdesp)
                        // 活动时间
                        // this.activeTime = [form.begintime, form.endtime] // 活动时间段

                        // 报名时间
                        if (form.enrolltimetype == 2) {
                            this.submitTime = [form.enrollbegintime, form.enrollendtime]
                        }

                        // 设置可编辑内容
                        let startTime = '',
                            endTime = '',
                            time = new Date().getTime()

                        // 取得报名时间节点
                        if (form.enrolltimetype == 2) {
                            startTime =  new Date(form.enrollbegintime).getTime()
                            endTime = new Date(form.enrollendtime).getTime()
                        } else {
                            startTime = new Date(form.begintime).getTime()
                            endTime = new Date(form.endtime).getTime()
                        }
                        
                        // 报名开始后不可编辑
                        if (time < startTime) {
                            this.startStatus = true
                        }

                        // 报名开始未截止都可编辑
                        if (time > endTime) {
                            this.endStatus = true
                        }

                        // 活动开始
                        if (time > new Date(form.begintime).getTime()) {
                            this.activeStatus = true
                        }
                    
                        //  活动结束
                        if (time > new Date(form.endtime).getTime() && this.copy !== 'copy') {
                            this.endActive = true
                        }

                        // 报名表单数据格式调整 
                        for (let i = 0; i < form.enrollformlist.length; i++) {
                            let optionsinfo = "",
                            data = []
                             // 是否必填
                            form.enrollformlist[i].isnotnull = form.enrollformlist[i].isnotnull == 1 ? true : false
                            
                            // if (form.enrollformlist[i].colname == "姓名" && form.enrollformlist[i].colindex == 1 ||  form.enrollformlist[i].colname == "手机" && form.enrollformlist[i].colindex == 2) {
                            //     delete form.enrollformlist[i]
                            //     continue
                            // }

                            // console.log('form.enrollformlist[i]',form.enrollformlist[i])
                            // console.log('form.enrollformlist[i].coltype',form.enrollformlist[i].coltype)
                            if (form.enrollformlist[i].coltype == 6 || form.enrollformlist[i].coltype == 7 || form.enrollformlist[i].coltype == 8) {
                                optionsinfo = form.enrollformlist[i].optionsinfo
                                // console.log('optionsinfo',optionsinfo)
                                let optionsinfoItem = optionsinfo.split(',')
                                // console.log('optionsinfoItem',optionsinfoItem)
                               for (let j = 0; j < optionsinfoItem.length; j++) {
                                    data.push({value: optionsinfoItem[j]})
                                    console.log('value', optionsinfoItem[j])
                                }

                                // 格式转换
                                // for (let j = 0; j < optionsinfo.length; j++) {
                                //     if (j == optionsinfo.length - 1) {
                                //         data += optionsinfo[j].value
                                //     } else {
                                //         data += optionsinfo[j].value + ","
                                //     }
                                // }
                                console.log('data',data)
                                form.enrollformlist[i].optionsinfo = data

                            } else {
                                form.enrollformlist[i].optionsinfo = ""
                            }
                        }

                        this.$nextTick(()=>{
                            this.form = form
                            console.log('form', this.form)
                        })
                        if(this.copy){
                            this.startStatus = false
                            this.activeStatus =false
                        }
                    },
                    error: data => {
                        this.$message.error(data.msg)
                        this.setLoading(false)
                    }
                })
            }
        },
        methods: {
            back(){
                this.$router.go(-1)
            },
            openDialog() {
                this.$refs.localCropper.openDialog()
            },
            delTableItem(index) {   // 报名列表 自定义栏位 删除
                console.log('index',index)
                this._JsonPosition({index: index, type: 'del'})
            },
            delSelectitem(index, seindex) {   // 报名表单 选项列表删除操作 index 自定义栏位下标 seindex 选项列表下标
                console.log('index',index,'seindex', seindex)
                this._JsonPosition({index: index, seindex:seindex, type: 'del'})
            },
            addSelectItem(index) {  // 报名表单 选项列表添加操作 index 自定义栏位下标 seindex 选项列表下标
                this._JsonPosition({index: index, type: 'add'})
            },
            _JsonPosition(json) {   // json 操作

                let enrollformlist = this.form.enrollformlist

                // 判断是对父类 还是 子类
                if (!json.seindex && json.type == 'del') {

                    // 对父类进行删操作
                    enrollformlist.splice(json.index,1)

                } else {

                    // 取得父元素
                    let enrollformitem = enrollformlist[json.index]

                    // 判断是新增还删除
                    if (json.type == 'add') {
                        let len = enrollformitem.optionsinfo.length;
                        enrollformitem.optionsinfo.push({value: ''})
                    } else if (json.type == 'del') {
                        enrollformitem.optionsinfo.splice(json.seindex,1)
                    }

                }


            },
            addTable(type) {    // 添加免费 / 付费票种

                // 初始化数据
                this.calcelTable()
                // 启动弹窗
                this.tableStatus = true
                // 初始化票种类型
                this.ticketinfolist.tickettype = type
            },
            calcelTable() { // 取消票种
                this.updayeTable = false
                this.tableStatus = false
                this.CheckIndex = null  // 重置选中下标
                this.ticketinfolist = { //票种信息list 
                            // ticketindex: '', // 票种序号
                            tickettype: 1, // 票种费用类型:1免费 2收费
                            name: '', // 票种名称
                            ticketcount: '', // 票数
                            uprice: '', // 票价格
                            isaudit: 0, // 是否审核：0不审核 1审核
                            memo: '', // 票种说明
                            seasonticketcount: 1, // 套票设置：默认为1
                            maxbuycountbysingle: 1, // 单次购买最多数
                            innerid: '', // 票种innerid
                }

            },
            submitTable() { // 添加票种信息

                let ticketinfolist = JSON.parse(JSON.stringify(this.ticketinfolist))
                // 数据格式判断
                // 判断票数格式是否正确
                if (typeof ticketinfolist.validcount !== 'number' && ticketinfolist.validcount % 1 !== 0) {
                    this.$message.error('票种张数格式错误，请输入正确的整数')
                    return
                }
                // 判断套票是否正确
                if (typeof ticketinfolist.seasonticketcount !== 'number' && 
                    (ticketinfolist.seasonticketcount < 1 || ticketinfolist.seasonticketcount > 100)) {
                    this.$message.error('套票设置格式错误，请输入正确的整数且为 1-100')
                    return
                }
                // 判断价格是否正确
                if (!/(^[-+]?[1-9]\d*(\.\d{1,2})?$)|(^[-+]?[0]{1}(\.\d{1,2})?$)/.test(ticketinfolist.uprice) && ticketinfolist.tickettype == 2) {
                    this.$message.error('票种价格必须为合法数字(正数，最多两位小数)')
                    return
                }
                // 判断票种名称
                if (ticketinfolist.name == "" || ticketinfolist.name.length == 0 || ticketinfolist.name.length > 6) {
                    this.$message.error('票种名称不能为空且不能超过6个字')
                    return
                }

                // 票种说明
                if (ticketinfolist.memo.length > 40) {
                    this.$message.error('票种说明不能超过40个字')
                    return
                }
                
                ticketinfolist.ticketcount=ticketinfolist.validcount
                if (this.updayeTable === false) {
                    //新增
                    // 不为编辑情况
                    this.form.ticketinfolist.push(ticketinfolist)
                    // 重置信息
                    this.calcelTable()
                } else {                                        
                    // 活动编辑情况下 并且不为复制活动情况
                    if (this.form.eventinnerid && !this.copy) {
                        // 最小余票数 > 当前票数 
                        if (ticketinfolist.lockcount > ticketinfolist.ticketcount) {
                            this.$message.info('余票数不能小于'+ticketinfolist.lockcount)
                            return
                        }
                    } 

                    // 循环绑定数据
                    for (let i = 0; i < this.form.ticketinfolist.length; i++) {
                        // innerid 为空时 通过下标修改票务信息
                        if (ticketinfolist.innerid == '') {                            
                            if (i == this.CheckIndex) {
                                this.form.ticketinfolist[this.CheckIndex] = ticketinfolist
                            }

                        } else {
                            // innerid 不为空时
                            if (this.form.ticketinfolist[i].innerid == ticketinfolist.innerid) {
                                this.form.ticketinfolist[i] = ticketinfolist
                            }
                        }                       
                    }
                    this.$nextTick(() => {
                        this.form.ticketinfolist = JSON.parse(JSON.stringify(this.form.ticketinfolist))
                    })
                    
                    // 重置信息
                    this.calcelTable()
                }
            },
            updatePw(index) {   // 编辑票务
                this.tableStatus =  true
                this.updayeTable = true

                // 票种类型
                this.ticketinfolist = JSON.parse(JSON.stringify(this.form.ticketinfolist[index]))
                // 选中票种下标
                this.CheckIndex = index

            },
            delPw(index) {  // 删除票务

                // 编辑且不为复制活动情况下
                if (this.form.eventinnerid && !this.copy) {
                    
                    if (this.form.ticketinfolist[index].isdelete == 0) {
                        this.$message.info('该票种有用户报名，不能删除。')
                    } else {
                        this.form.ticketinfolist.splice(index,1)
                    }

                } else {
                    this.form.ticketinfolist.splice(index,1)
                }
                
            },
             // 详情信息 
            getUEditorContent(content) {
                this.form.eventdesp = content
            },
            //设置自定义报名表单
            setZidingyiForms(val) {

                // 1 单行文本框 2 数字文本框  3 日期选择框  4 邮箱输入框 5 多行文本框6 单选按钮框 7 多选按钮框 8 下拉选择框
                this.form.enrollformlist.push({
                     colinnerid: '', // 表单InnerID
                        colname: '', // 字段名称 
                        colindex: '', // 序号 
                        coltype: val, // 字段类型： 1 单行文本框 2 数字文本框  3 日期选择框  4 邮箱输入框 5 多行文本框6 单选按钮框 7 多选按钮框 8 下拉选择框  \n
                        placeholder: '', // 字段提示语
                        optionsinfo: [{value:''},{value:''}], // 下拉选项表：表单提交时 多个以逗号隔开
                        isnotnull: '', // 是否必填"
                        ispublic: 0,    // 是否公开
                })
            },

            // 选择活动地址
            showLocationDialog() {
                this.locationDialogStatus = true
            },

            getThePosition(data) {
                this.form.address = data.province + data.city + data.detailPosition
                this.form.mapprovince = data.province
                this.form.mapcity = data.city
                this.form.latitude_baidu = data.point.lat
                this.form.longitude_baidu = data.point.lng
                this.locationDialogStatus = false
            },


            // 设置图片信息（本地）
            _setImage(img) {
                // 发生头像图片变更操作
                this.updateImgStatus = true
                // $("input[name=headerimg]:checked").prop('checked',false)    // 清除选中头像
                // console.log(img)
                this.time = new Date().getTime()
                
                this.form.coveratturlid = img
                // this.form.logodata = img

                //  this.$refs.coverfile.setImage( this.starMgtForm.logodata.furl)

                // 设置图片
                // $this.$refs.coverfile.setImage($this.form.starlogourl)
            },
            saveEnrolleventinfo() { // 提交活动信息

                // if (this.activeTime) {
                //     // console.log(this.activeTime)
                //     this.form.begintime = this.activeTime[0]  // 活动开始时间
                //     this.form.endtime = this.activeTime[1]  // 活动结束时间
                //     // fecha.format(new Date(this.times[0]), 'yyyy-MM-dd HH:mm')
                // } else {
                //     this.$message.error('请选择活动时间')
                //     // console.log('no activeTime')
                //     this.form.begintime = ""
                //     this.form.endtime  = ""
                //     return 
                // } 

                if (this.form.enrolltimetype == 2) {
                    if (this.submitTime) {
                        console.log(this.submitTime)
                        this.form.enrollbegintime = this.submitTime[0] // 报名开始时间
                        this.form.enrollendtime = this.submitTime[1]  // 报名结束时间
                    } else {
                        console.log('no activeTime')
                        this.enrollbegintime = ""
                        this.enrollendtime = ""
                    }
                }

                let data = JSON.parse(JSON.stringify(this.form))

                // console.log('data.enrollformlist',data.enrollformlist)

                // if (data.enrollformlist.length > 0) {
                    this._saveEnrolleventinfoJSONPosition(data.enrollformlist)
                // }

                // console.log('data.enrollformlist',data.enrollformlist)

                data.ticketinfolist = JSON.stringify(data.ticketinfolist)
                data.enrollformlist = JSON.stringify(data.enrollformlist)

                delete data.coveratturlid.type
               
                data.coveratturlid = JSON.stringify(data.coveratturlid)
                


                // 复制活动情况下
                if (this.$route.query.title) {
                    console.log('复制活动')
                    data.eventinnerid = ""
                    data.iscopy = 1
                }

                this.setLoading(true)
                console.log(data)
                saveEnrolleventinfo({
                    data: data,
                    success: data => {
                        this.setLoading(false)
                        this.$message.success('保存成功');
                        setTimeout(()=>{
                            this.$router.push({name: "activeOperateIndex"})
                        },500)
                    },
                    error: data => {
                        this.$message.error(data.msg);
                        this.setLoading(false)
                    }
                })
            },
            _saveEnrolleventinfoJSONPosition(enrollformlist) { // 提交活动信息更多数据票种信息表单处理
                // let enrollformlist = enrollformlist
        
                    for (let i = 0; i < enrollformlist.length; i++) {
                        let optionsinfo = "",
                        data = ""

                         // 是否必填
                        enrollformlist[i].isnotnull = enrollformlist[i].isnotnull == true ? 1 : 0

                        //  多选文本、多选按钮、单选按钮 情况下
                        if (enrollformlist[i].coltype == 6 || enrollformlist[i].coltype == 7 || enrollformlist[i].coltype == 8) {
 
                            optionsinfo = enrollformlist[i].optionsinfo
                            // 格式转换
                            for (let j = 0; j < optionsinfo.length; j++) {
                                if (j == optionsinfo.length - 1) {
                                    data += optionsinfo[j].value
                                } else {
                                    data += optionsinfo[j].value + ","
                                }
                            }
                            enrollformlist[i].optionsinfo = data
                        } else {
                            enrollformlist[i].optionsinfo = ""
                        }
                    }
            },
            ...mapActions([
                'setLoading'
            ])
        },
        components: {
            Upload,
            UEditor,
            ChooseLocation,
            ShopLocalCropper,
        }
    }
</script>

<style lang="scss" type="text/scss">
    .CreateActive {
        .to{
            margin: 0 13px;
        }              
        .el-form-item.is-required {
            .el-form-item__label::after{
                    content: "*";
                    color: #F56C6C;
                    margin-left: 4px;
            }
            .el-form-item__label::before {
                display: none;
            }
        }
        .address {
            .el-input.is-disabled .el-input__inner {
                color: #303133;
                background-color: #fff; 
                cursor: pointer;
            }
        }
        .bgc {
            margin-top: 20px;
            &:first-child {
                margin-top: 0
            }
        }
        .el-form-item__label {
            color: #303133;
        }
        .el-input__icon {
            line-height: normal
        }
        .ue_btn {
            display: none;
        }
        .none {
            .el-table__empty-block {
                display: none;
            }
        }
        .positionbtn {
            text-align: center;
        }
        header {
            h1 {
                margin-bottom: 30px;
                padding-left: 10px;
                border-left: solid 2px #409EFF; 
                font-size: 16px;
            }
        }
        .flexd {
            display: flex;
            flex-wrap: nowrap;
            -ms-flex-wrap: nowrap;
            justify-content: space-between;
            i {
                cursor: pointer;
            }
        }
        .txt {
            color: #999;
            font-size: 14px;
        }
        .enrollcityname {
            .el-select {
                width: 400px;
                .el-select__caret {
                    line-height: 32px;
                }
            }
        }
        .upload {
            height: 178px;
            .avatar-uploader {
                width: 318px;
                height: 178px;
                color: #dcdfe6;
                font-size: 50px;
                line-height: 178px;
                border: 1px solid #DCDFE6;
                text-align: center;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .uploadFileBox {
                float: left;
                margin-left: 12px;
                margin-top:  40px;
            }
        }
        .el-input {
            max-width: 400px;

            input {
                width: 100%;
            }
        }
        .ticket-info {
            .el-radio__label {
                color: #303133;
            }
            .el-input {
               width: 132px;  
            }
            .table-btn {
                margin-bottom: 30px;
                width: 879px;
                text-align: center;
                margin-top: 20px;
                .el-button {
                    margin: 0 15px;
                }
            }
            .ticket-info-table {
                width: 879px;
                border: solid 1px #e5e5e5;
                padding: 14px 19px;
                box-sizing: border-box;
                .flexd {
                    margin-bottom: 20px;
                    .txt {
                        &:last-child {
                            margin-left: 24px;
                        }
                        &:first-child {
                            margin: 0 5px;
                        }
                    }
                }
                .el-input {
                    width: 132px;
                } 
                .bmtable-content {
                    width: 714px;
                }
            }
        }
        .el-tooltip__popper.is-dark {
            color: #606266;
            background: #fff;
        }
        .bmtable {
            .content {
                width: 879px;
                .title {
                margin: 20px 0 32px 0;
                }
            }
            .list-title,
            .maxinput {
                width: 278px;
            }
            .el-input {
                width: 128px;
            }
            .el-input,
            .flexd {
                margin-top: 20px;
            }     
            .left {
                width: 560px;
                .name {
                    width: 128px;
                }
                .el-checkbox {
                    line-height: 32px;
                }
                .maxinput {
                    width: 278px !important;
                }
                .list {
                    // width: 322px;
                    width: 282px;
                    i.el-icon-delete {
                        line-height: 32px;
                    }
                    .list-title {
                        height: 32px;
                        line-height: 32px;
                    }
                    .el-button--primary.is-plain {
                        width: 278px;
                    }
                    i.el-icon-delete {
                        position: absolute;
                        top: 20px;
                        right: -42px;
                    }
                }
                .input,
                .name  {
                    .el-input {
                        margin-top: 0;
                    }
                }
                .flexd {
                    align-items: center;
                }
                .item-list {
                    align-items: self-start !important;
                    .flexd {
                        position: relative;
                        margin-top: 0;
                    }
                    .el-button,
                    .maxinput {
                        margin-top: 20px;
                    }
                }
            }
            .right {
                margin-left: 40px;
                padding: 20px 12px;
                width: 210px;
                height: 336px;
                border:1px solid #D8DCE6;
                box-sizing: border-box;
                background: #f5f5f5;
                p {
                    color: #303133;
                    font-size: 14px;
                }
                li {
                    justify-content: flex-start;
                    align-items: center;
                    margin: auto;
                    margin-top: 20px;
                    padding: 0 5px;
                    width: 170px;
                    height: 28px;
                    line-height: 28px;
                    box-sizing: border-box;
                    background: #fff;
                    cursor: pointer;
                    img {
                        margin-right: 5px;
                    }
                }
            }
        }
    }
</style>